import React from 'react'
import { latLng, Marker, Popup } from '@fareye/ui'
import FieldValue from './FieldValue'
import { isEmpty, toTileCase, isNullUndefinedAndEmpty } from '@fareye/utils'
import { useTranslation } from '@fareye/common'
import { labelColor, valueColor } from '@fareye/configs'

export const CurrentLocationMarker = ({
  data,
  selected,
  lastLocation,
  icon,
  moveMarker,
  trackingProvider
}: any) => {
  const { t } = useTranslation()
  let {
    latestJourney,
    currentLocation,
    transportMode,
    status,
    vesselName,
    vesselNo,
    vehicleNo,
    transporterName
  } = data
  let { landmark, speed } = currentLocation || {}
  const [tempState, setState] = React.useState(0)

  const history = data.history || []
  // When a tracking provider filter is applied, don't fall back to the live/unfiltered
  // vehicle position — it belongs to a different source than the one the user selected.
  const hasLastLocation = !isEmpty(lastLocation) && lastLocation?.latitude != null && lastLocation?.longitude != null
  const canFallback = !trackingProvider
  const latitude = hasLastLocation
    ? lastLocation?.latitude
    : canFallback && latestJourney
    ? latestJourney?.latestLocation?.latitude
    : canFallback
    ? currentLocation?.latitude
    : undefined
  const longitude = hasLastLocation
    ? lastLocation?.longitude
    : canFallback && latestJourney
    ? latestJourney?.latestLocation?.longitude
    : canFallback
    ? currentLocation?.longitude
    : undefined
  const [latLngObject, setLatLngObject] = React.useState({
    latLng: { lat: latitude, lng: longitude },
    latLngIndex: 0
  })
  if (latestJourney) {
    landmark = latestJourney?.latestLocation?.landmark
    speed = latestJourney?.latestLocation?.speed
    transporterName = latestJourney?.transporterName

    vehicleNo = latestJourney?.vehicleNo
    vesselNo = latestJourney?.vesselNo
    vesselName = latestJourney?.vesselName
    transportMode = latestJourney?.transportMode
  }
  if (!isEmpty(lastLocation)) {
    landmark = lastLocation?.landmark
    speed = lastLocation?.speed
    vehicleNo = lastLocation?.vehicleNo
  }
  const openPopup = (marker: any) => {
    if (marker && selected) {
      marker.leafletElement.openPopup()
    }
    if (marker && !selected) {
      marker.leafletElement.closePopup()
    }
  }
  const getLatLongObj: any = () => {
    const historyLength = history.length
    if (historyLength && latLngObject.latLngIndex !== historyLength - 1) {
      const index = latLngObject.latLngIndex + 1
      return {
        latLng: { lat: history[index].latitude, lng: history[index].longitude },
        latLngIndex: index
      }
    } else if (historyLength - 1 === latLngObject.latLngIndex) {
      return {
        latLng: { lat: history[0].latitude, lng: history[0].longitude },
        latLngIndex: 0
      }
    }
  }
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`

  React.useEffect(() => {
    if (!moveMarker && latitude && longitude) {
      setLatLngObject({
        latLng: { lat: latitude, lng: longitude },
        latLngIndex: 0
      })
    }
  }, [latitude, longitude])

  React.useEffect(() => {
    let timeoutID: any = 0
    if (moveMarker && history.length) {
      timeoutID = setTimeout(() => {
        // updates position every 1 sec
        setLatLngObject(getLatLongObj())
      }, 1000)
    }
    return () => {
      clearTimeout(timeoutID)
    }
  }, [latLngObject])
  function fieldRenderingOnTransporterMode(mode: string) {
    switch (mode) {
      case 'road':
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('VehicleNo')}
              value={vehicleNo}
              valueStyle={{
                color: valueColor,
                textTransform: 'uppercase'
              }}
            />
          </>
        )
      case 'ocean':
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('Vessel No')}
              value={vesselNo}
              valueStyle={{ color: valueColor }}
            />
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('Vessel Name')}
              value={vesselName}
              valueStyle={{ color: valueColor }}
            />
          </>
        )
      case 'air':
      case 'rail':
      default:
        return (
          <>
            <FieldValue
              style={{
                marginBottom: 4,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
              labelStyle={{
                color: labelColor,
                marginBottom: 2
              }}
              label={t('VehicleNo')}
              value={vehicleNo}
              valueStyle={{ color: valueColor }}
            />
          </>
        )
    }
  }
  return (
    <>
      {latitude && longitude &&
        latLngObject.latLng.lat != null && latLngObject.latLng.lng != null &&
        isFinite(Number(latLngObject.latLng.lat)) && isFinite(Number(latLngObject.latLng.lng)) && (
        <Marker
          position={latLng(latLngObject.latLng.lat, latLngObject.latLng.lng)}
          icon={icon}
          // ref={el => openPopup(el)}
          eventHandlers={{
            click: () => setState(tempState + 1)
          }}
        >
          {!moveMarker && (
            <Popup minWidth={149}>
              {status && (
                <FieldValue
                  style={{ marginBottom: 4 }}
                  labelStyle={{ color: labelColor }}
                  label={`${t('Status')}${':'} `}
                  value={t(status) || '-'}
                />
              )}
              <FieldValue
                style={{ marginBottom: 4 }}
                labelStyle={{ color: labelColor }}
                valueStyle={{ color: valueColor }}
                label={t('Speed')}
                value={speedStr}
              />
              {/* <FieldValue
              style={{ marginBottom: 4 }}
              labelStyle={{ color: '#727272' }}
              valueStyle={{ color: '#212121' }}
              label={ata ? 'ATA' : 'ETA'}
              value={ata ? displayTime(ata) : displayTime(eta)}
            /> */}
              <hr />
              <FieldValue
                style={{
                  marginBottom: 4,
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}
                labelStyle={{
                  color: labelColor,
                  marginBottom: 2
                }}
                label={t('Current Location')}
                valueStyle={{ color: valueColor }}
                value={toTileCase(landmark)}
              />
              <FieldValue
                style={{
                  marginBottom: 4,
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}
                labelStyle={{
                  color: labelColor,
                  marginBottom: 2
                }}
                valueStyle={{ color: valueColor }}
                label={t('Current Carrier')}
                value={t(toTileCase(transporterName))}
              />
              {fieldRenderingOnTransporterMode(transportMode)}
            </Popup>
          )}
        </Marker>
      )}
    </>
  )
}
